import { MapPin, ShieldCheck } from "lucide-react";
import { useLang } from "@/LangContext";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
  const { t } = useLang();

  const links = [
    { id: "ecosistema", label: t.nav.ecosystem },
    { id: "areas", label: t.nav.areas },
    { id: "plan-maestro", label: t.footer.masterplan },
    { id: "naming", label: t.nav.naming },
    { id: "gobernanza", label: t.footer.governance },
    { id: "contribuir", label: t.footer.contribute },
    { id: "contacto", label: t.nav.contact },
  ];

  return (
    <footer
      data-testid="footer"
      className="border-t border-white/10 bg-[#07090D]"
    >
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <span className="relative block h-10 w-10">
                <span className="absolute inset-1 rotate-45 border-2 border-amber-400" />
                <span className="absolute inset-0 flex items-center justify-center font-display text-lg font-bold text-amber-400">
                  D
                </span>
              </span>
              <div>
                <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-white">
                  {t.footer.entity}
                </p>
                <p className="font-code text-[10px] uppercase tracking-[0.3em] text-amber-400/90">
                  {t.footer.project}
                </p>
              </div>
            </div>
            <p
              data-testid="footer-location"
              className="mt-6 flex items-start gap-2.5 text-sm text-slate-400"
            >
              <MapPin size={16} className="mt-0.5 shrink-0 text-amber-400" />
              {t.footer.location}
            </p>
          </div>

          <div>
            <p className="font-code text-[10px] uppercase tracking-[0.35em] text-slate-500">
              {t.footer.navTitle}
            </p>
            <nav className="mt-5 flex flex-col items-start gap-3">
              {links.map((l) => (
                <button
                  key={l.id}
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => scrollToId(l.id)}
                  className="text-sm text-slate-400 transition-colors hover:text-amber-400"
                >
                  {l.label}
                </button>
              ))}
            </nav>
          </div>

          <div>
            <p className="font-code text-[10px] uppercase tracking-[0.35em] text-slate-500">
              {t.footer.governance}
            </p>
            <p
              data-testid="footer-confidentiality"
              className="mt-5 flex items-start gap-2.5 text-sm leading-relaxed text-slate-400"
            >
              <ShieldCheck size={16} className="mt-0.5 shrink-0 text-amber-400" />
              {t.footer.confidentiality}
            </p>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-8">
          <p
            data-testid="footer-rights"
            className="font-code text-[11px] uppercase tracking-[0.22em] text-slate-600"
          >
            {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
}
